import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

/**
 * Ресурс і операція, за якими видно пункт меню «Адміністрування диска» й
 * відкриваються сторінки `/disk/admin/*`: ключ прав `DiskAdmin`
 * (`DiskAdminRule::ACCESS`) у `GET /services/auth/permissions`. Той самий вхід
 * у `GATED_MENU_ITEMS['Disk.Admin']`, щоб пункт меню й маршрут не розходилися.
 */
export const DISK_ADMIN_GATE = { resource: 'Disk.Admin', operation: 'read_collection' } as const

/** Чи адміністратор диска (право з бека, а не роль: ієрархія ролей живе в `security.yaml`). */
export const CheckDiskAdminAccessTask = (): boolean =>
    CheckGlobalResourceAccessTask(DISK_ADMIN_GATE.resource, DISK_ADMIN_GATE.operation)
